import { useSelector } from "redux/store";

export const useGetAuth = () => {
  return {
    auth: useSelector(state => state.firebase.auth),
    authError: useSelector(state => state.firebase.authError),
    profile: useSelector(state => state.firebase.profile),
  };
};
